"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildGatsbyImageDataObject = exports.buildFixedObject = exports.buildFluidObject = void 0;
var gatsby_plugin_image_1 = require("gatsby-plugin-image");
var imgix_js_core_wrapper_1 = require("./common/imgix-js-core-wrapper");
var buildGatsbyImageDataBaseArgs_1 = require("./modules/gatsby-plugin/buildGatsbyImageDataBaseArgs");
var internalObjectBuilders = __importStar(require("./modules/gatsby-plugin/objectBuilders"));
var buildFluidObject = function (_a) {
    var imgixClientOptions = _a.imgixClientOptions, args = __rest(_a, ["imgixClientOptions"]);
    return internalObjectBuilders.buildFluidObject(__assign(__assign({}, args), { client: imgix_js_core_wrapper_1.createImgixURLBuilder(imgixClientOptions) }));
};
exports.buildFluidObject = buildFluidObject;
var buildFixedObject = function (_a) {
    var imgixClientOptions = _a.imgixClientOptions, args = __rest(_a, ["imgixClientOptions"]);
    return internalObjectBuilders.buildImgixFixed(__assign(__assign({}, args), { client: imgix_js_core_wrapper_1.createImgixURLBuilder(imgixClientOptions) }));
};
exports.buildFixedObject = buildFixedObject;
var buildGatsbyImageDataObject = function (_a) {
    var imgixClientOptions = _a.imgixClientOptions, args = __rest(_a, ["imgixClientOptions"]);
    var imgixClient = imgix_js_core_wrapper_1.createImgixURLBuilder(imgixClientOptions);
    var generateImageDataArgs = buildGatsbyImageDataBaseArgs_1.buildGatsbyImageDataBaseArgs(__assign(__assign({}, args), { imgixClient: imgixClient }));
    return gatsby_plugin_image_1.generateImageData(generateImageDataArgs);
};
exports.buildGatsbyImageDataObject = buildGatsbyImageDataObject;
//# sourceMappingURL=pluginHelpers.browser.js.map